import { BiChevronRight } from "react-icons/bi";
import { Link } from "react-router-dom";
import styled from "styled-components";

const BreadCrumbWrapper = styled.div`
    width: 100%
    padding-bottom: 2.5rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;

     .page-title {
    font-size: 1.2rem;
    color: ${({ theme }) => theme.text.primary};
    text-transform: capitalize;
    font-weight: 500;

    :hover {
      color: ${({ theme }) => theme.text.secondary};
      text-decoration: underline;
    }

    @media screen and (max-width: ${({ theme }) => theme.screen.mobile}) {
      font-size: 1rem;
    }
  }

   .crumb-title {
    color: ${({ theme }) => theme.text.prim_100};
    font-size: 1.2rem;
  }

    .svg-container{
        display: flex;
        align-items: center;
        gap: 5px;
    }
`;

export interface ICrumb {
  currentPage: string;
  previousPage: string;
  previousPageLink: string;
}

export function DRFCrumb({
  currentPage,
  previousPage,
  previousPageLink,
}: ICrumb) {
  return (
    <BreadCrumbWrapper>
      <div className="">
        <Link className="page-title" to={previousPageLink}>
          {previousPage}
        </Link>
      </div>
      <div className="svg-container">
        <BiChevronRight size={40} />
      </div>
      <h2 className="crumb-title">{currentPage}</h2>
    </BreadCrumbWrapper>
  );
}
